import OadpAttributeBoolean from './oadp-attribute-boolean';
export default OadpAttributeBoolean;
